// extracted by mini-css-extract-plugin
module.exports = {"root":"AfterBackImages_root__2mcCW","title":"AfterBackImages_title__19gnI","images":"AfterBackImages_images__1Oqtv"};